import * as types from '../mutation-types';

const state = {
  isOpenSidenav: false
};

const getters = {
  isOpenSidenav: () => state.isOpenSidenav
};

const actions = {
  toggleSidenav: ({ commit }, status) => {
    commit(types.TOGGLE_SIDENAV, status);
  }
};

const mutations = {
  [types.TOGGLE_SIDENAV](_, status) {
    state.isOpenSidenav = status;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/sidenav.js